/** Team → Invite to Team (Super Admin, ISO owner, or agent with Can Build a Downline). */
import React, { useState } from 'react';
import { Copy } from 'lucide-react';
import { toast } from 'sonner';
import api from '../lib/api';
import useAuthStore from '../lib/auth-store';
import { Card, btnPrimary, errorText, inputCls } from '../components/finance/financeUi';

export default function TeamInvitePage() {
  const role = useAuthStore((s) => s.user?.role);
  const [f, setF] = useState({ email: '', first_name: '', last_name: '', proposed_role: role === 'iso_agent' ? 'iso_subagent' : 'iso_agent' });
  const [link, setLink] = useState(null);
  const send = async (e) => {
    e.preventDefault();
    try { const r = await api.request('/enrollment/invites', { method: 'POST', body: JSON.stringify(f) }); setLink(`${window.location.origin}${r.path}`); } catch (err) { toast.error(errorText(err)); }
  };
  return (
    <div className="mx-auto max-w-2xl space-y-6" data-testid="team-invite-page">
      <h1 className="text-2xl font-bold">Invite to Team</h1>
      <Card title="New invitation">
        <form onSubmit={send} className="grid gap-3 px-5 py-4 sm:grid-cols-2">
          <input required type="email" className={inputCls} placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="invite-email" />
          <select className={inputCls} value={f.proposed_role} onChange={(e) => setF({ ...f, proposed_role: e.target.value })} data-testid="invite-role">
            {role !== 'iso_agent' && <option value="iso_agent">Agent</option>}<option value="iso_subagent">Subagent</option>
          </select>
          <input className={inputCls} placeholder="First name" value={f.first_name} onChange={(e) => setF({ ...f, first_name: e.target.value })} data-testid="invite-first-name" />
          <input className={inputCls} placeholder="Last name" value={f.last_name} onChange={(e) => setF({ ...f, last_name: e.target.value })} data-testid="invite-last-name" />
          <button type="submit" className={btnPrimary} data-testid="invite-submit">Create invite link</button>
        </form>
        {link && <div className="flex items-center gap-2 px-5 pb-4 text-sm" data-testid="invite-link"><code className="truncate rounded bg-muted px-2 py-1">{link}</code><button type="button" aria-label="Copy link" onClick={() => { navigator.clipboard?.writeText(link); toast.success('Copied'); }} data-testid="invite-copy"><Copy className="h-4 w-4" /></button></div>}
      </Card>
      <p className="text-xs text-muted-foreground">The invitee joins your team after MSC approves the request. Economics are assigned after approval, never by the invitee.</p>
    </div>
  );
}
